module.exports = __webpack_public_path__ + "static/familia-f2aad335907b9c8373f98f0b08cdbb6d.jpg";